import {LOOKUP_ENUM} from "../../dictionary/core/lookup.enum";
export const QUOTE_SERVICE_TERM = LOOKUP_ENUM.QUOTE_SERVICE_TERM;
